module.exports = __webpack_public_path__ + "static/img/leiniao-benefit-combo.4ce60ca7.png";